
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 44,
  width: 41,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-bright, #e3d2e9)",
  d: "M24.14 0q9.36 1.78 9.02 10.85a3.28 3.13 39.9 0 0 .11.97q1.14 4.28-.57 8-1.71 3.72-1.9 4.77a.6.59-76.5 0 0 .41.68q4.57 1.35 5.6 1.87 6.01 3.02 7.19 11.07V41H.88q-.2-.35-.88-.6v-2.7Q.94 31 5.92 27.44q.79-.57 6.9-2.32a.63.62 75.6 0 0 .44-.75q-.73-2.95-1.76-4.4a2.02 1.94-69.1 0 1-.35-.83q-.87-5.01-.65-5.66.76-2.2.78-3.87C11.32 4.21 14.69.94 20.1 0h4.04Zm-5.96 27.24q-8.5 1.55-11.3 3.34-2.7 1.73-3.6 6.7a.55.55 0 0 0 .54.65h36.03a.55.55 0 0 0 .54-.64c-1.28-7.97-8.12-8.67-15.3-10.11a.35.35 0 0 1-.14-.62q3.19-2.4 3.73-6.03a2.38 2.36 68.5 0 1 .5-1.16q2.52-3.17.8-6.94a1.89 1.89 0 0 1-.14-1.04c.98-6.48-4.09-9.03-9.5-8.11-4.56.77-6.66 3.57-5.82 8.24a1.56 1.49 54.5 0 1-.14.96q-1.25 2.39-.18 5.61c.43 1.27 1.42.99 1.45 3.07.03 1.79.63 3.71 2.19 4.85q.47.34.61.52a.45.44-24.7 0 1-.27.71Z"
})));

      const __svgRaw = "<svg height=\"44\" width=\"41\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0.00 0.00 44.00 41.00\">\r\n<path fill=\"var(--theme-bright, #e3d2e9)\" d=\"\r\n  M 24.14 0.00\r\n  Q 33.50 1.78 33.16 10.85\r\n  A 3.28 3.13 39.9 0 0 33.27 11.82\r\n  Q 34.41 16.10 32.70 19.82\r\n  Q 30.99 23.54 30.80 24.59\r\n  A 0.60 0.59 -76.5 0 0 31.21 25.27\r\n  Q 35.78 26.62 36.81 27.14\r\n  Q 42.82 30.16 44.00 38.21\r\n  L 44.00 41.00\r\n  L 0.88 41.00\r\n  Q 0.68 40.65 0.00 40.40\r\n  L 0.00 37.70\r\n  Q 0.94 31.00 5.92 27.44\r\n  Q 6.71 26.87 12.82 25.12\r\n  A 0.63 0.62 75.6 0 0 13.26 24.37\r\n  Q 12.53 21.42 11.50 19.97\r\n  A 2.02 1.94 -69.1 0 1 11.15 19.14\r\n  Q 10.28 14.13 10.50 13.48\r\n  Q 11.26 11.28 11.28 9.61\r\n  C 11.32 4.21 14.69 0.94 20.10 0.00\r\n  L 24.14 0.00\r\n  Z\r\n  M 18.18 27.24\r\n  Q 9.68 28.79 6.88 30.58\r\n  Q 4.18 32.31 3.28 37.28\r\n  A 0.55 0.55 0.0 0 0 3.82 37.93\r\n  L 39.85 37.93\r\n  A 0.55 0.55 0.0 0 0 40.39 37.29\r\n  C 39.11 29.32 32.27 28.62 25.09 27.18\r\n  A 0.35 0.35 0.0 0 1 24.95 26.56\r\n  Q 28.14 24.16 28.68 20.53\r\n  A 2.38 2.36 68.5 0 1 29.18 19.37\r\n  Q 31.70 16.20 29.98 12.43\r\n  A 1.89 1.89 0.0 0 1 29.84 11.39\r\n  C 30.82 4.91 25.75 2.36 20.34 3.28\r\n  C 15.78 4.05 13.68 6.85 14.52 11.52\r\n  A 1.56 1.49 54.5 0 1 14.38 12.48\r\n  Q 13.13 14.87 14.20 18.09\r\n  C 14.63 19.36 15.62 19.08 15.65 21.16\r\n  C 15.68 22.95 16.28 24.87 17.84 26.01\r\n  Q 18.31 26.35 18.45 26.53\r\n  A 0.45 0.44 -24.7 0 1 18.18 27.24\r\n  Z\"\r\n/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/person.60830fbedaa24f2148a71442a851ccfc.svg"),
        {
          React: SvgPerson,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      